/* eslint-disable */

import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    data () {
       return {
       }
    },
    computed: {
        ...mapState({
            siteID: state => state.customer.siteID,
            user: state => state.customer.user,
            customerID: state => state.customer.customerID,
            userID: state => state.customer.userID,
            sites: state => state.customer.sites,
            employees: state => state.customer.employees,
            settings: state => state.customer.settings,
            rules: state => state.customer.rules,
            tasksLoaded: state => state.tasks.tasksLoaded,
         }),

        /**
         * Beta sites are Nilay and Paul's site
        */
      
        isBetaSite() {
            return ['4dd2fc2c-d7cb-11e9-bac0-0ad6daef1536', '437dd9f9-7850-11ea-ac82-160d1264b43d'].includes(this.siteID);
        },

        /**
         * Tx Presenter per-site access gate. Replaces the pre-release
         * Super-Admin-only check on the sidebar entry, route guards, and
         * Patient Profile "Tx Plans" button. Mirrors the full-mixin version
         * in mixin.js — duplicated here because Sidebar.vue uses the leaner
         * topmixin (no allSettings keyed lookup). Super Admin always has
         * access (safety net). Per-site flag: TX_PRESENTER_ENABLED='TRUE'
         * in teamio.settings (toggle via Gautam → SuperAdmin → Features).
         */
        canAccessTxPresenter() {
            if (this.user && this.user.Role === 'Super Admin') return true;
            if (!Array.isArray(this.settings)) return false;
            const flag = this.settings.find((s) => s && s.Property === 'TX_PRESENTER_ENABLED');
            return !!(flag && flag.PropertyValue === 'TRUE');
        },

        /**
         * Whether to SHOW the Insurance Verification entry in the sidebar. Strictly
         * the per-site flag INSURANCE_VERIFICATION_ENABLED='TRUE' in teamio.settings.
         *
         * ⛔ DELIBERATELY does NOT carry canAccessTxPresenter's Super-Admin bypass, and
         * that divergence is the whole point. The backend's /dashboard, /verify and
         * /detail are feature-flag GATED and answer 403 "Insurance Verification is not
         * enabled for this site". With the bypass, a Super Admin saw this icon on every
         * site — 32 of 33 of which are not enabled — so a single click produced a
         * guaranteed 403, and Lumigo pages that 403 to Slack as a "403 Client error
         * response" issue. (Observed 2026-08-05 on Mint prod: one click, one page.)
         * Showing a person a button whose only possible outcome is an alert is not a
         * safety net, it is a tripwire.
         *
         * The real escape hatch is preserved elsewhere and is enough: the route guard in
         * Routes.js still lets a Super Admin reach /app/insurance-verification directly,
         * so we can never lock ourselves out of a site we need to debug — we just have
         * to mean it by typing the URL rather than by misclicking a nav icon.
         *
         * SECOND TERM (added with the CASL gate): the site flag says the PRACTICE is on;
         * `$can('view','insurance-verification')` says THIS PERSON may spend. Every click
         * on that page is a billed Stedi check, so both have to be true to show the entry.
         * The ability itself is derived from the same flag in ability.js, so this is not
         * circular — the ability adds the role term and the per-role FEATURE_PERMISSIONS
         * override that the flag alone cannot express.
         */
        showInsuranceVerificationNav() {
            if (!Array.isArray(this.settings)) return false;
            const flag = this.settings.find((s) => s && s.Property === 'INSURANCE_VERIFICATION_ENABLED');
            if (!(flag && flag.PropertyValue === 'TRUE')) return false;
            return !!(typeof this.$can === 'function' && this.$can('view', 'insurance-verification'));
        }
    }
}